import { Component, EventEmitter, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription, take } from 'rxjs';
import { AccessTypeSelection } from '../../../../../common/enums/access-type-selection.enum';
import { selectAddUserStepperSelectedAccess } from '../../../../store/selectors/grant-revoke-permissions.selector';
import { AdobeLaunchService } from '../../../../services/adobe-launch/adobe-launch.service';
import { AdobeTagging } from '../../../../utils/decorators/dev/adobe-launch';
import { configData } from './gaf-mvp-access-agreement.adobe';
import { ContentUtil } from '../../../../utils/content/content.util';
import { NgIf } from '@angular/common';

@AdobeTagging(configData)
@Component({
    selector: 'zci-gaf-mvp-access-agreement',
    templateUrl: 'gaf-mvp-access-agreement.component.html',
    styleUrls: ['gaf-mvp-access-agreement.component.scss'],
    standalone: true,
    imports: [NgIf],
})
export class GafMvpAccessAgreementComponent implements OnInit, OnDestroy {
    private store = inject(Store);
    protected adobeLaunchService = inject(AdobeLaunchService);

    readonly accessTypeSelection = AccessTypeSelection;

    @Input() nextStepClicked: EventEmitter<any> = new EventEmitter<any>();
    @Input() nextStepReady: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Input() locationChanged: EventEmitter<any>;

    selectedAccess$: Observable<AccessTypeSelection> = this.store.select(
        selectAddUserStepperSelectedAccess,
    );

    accessAgreementHeading = ContentUtil.grantorFragmentContent.add_user.frmcTrmAgreement.heading;

    infoOnlyAccessAgreement =
        ContentUtil.grantorFragmentContent.add_user.frmcTrmAgreement
            .frmcTrmAgreementInformationOnly;

    limitedOnlyAccessAgreement =
        ContentUtil.grantorFragmentContent.add_user.frmcTrmAgreement.frmcTrmAgreementLimitedAccess;

    isInfoOnly: boolean = false;

    isLimitedOnly: boolean = false;
    accessType: AccessTypeSelection;

    private subs: Subscription = new Subscription();

    ngOnInit(): void {
        this.subs.add(
            this.selectedAccess$.pipe(take(1)).subscribe((accessType) => {
                this.accessType = accessType;
                switch (accessType) {
                    case this.accessTypeSelection.INFORMATION_ONLY:
                        this.adobeInfoOnlyPageLoad();
                        this.isInfoOnly = true;
                        this.locationChanged.emit('access_agreement_info_only');
                        break;
                    case this.accessTypeSelection.LIMITED_ACCESS:
                        this.adobeLimitedOnlyPageLoad();
                        this.isLimitedOnly = true;
                        this.locationChanged.emit('access_agreement_for_limited');
                        break;
                }
            }),
        );
        this.subs.add(this.nextStepClicked.subscribe(this.onNextStepLoad.bind(this)));
    }

    onNextStepLoadAdobeEventInfoOnly(): void { }

    onNextStepLoadAdobeEventLimited(): void { }

    private adobeInfoOnlyPageLoad(): void { }

    private adobeLimitedOnlyPageLoad(): void { }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    private onNextStepLoad(): void {
        this.tagNextStepLoadAdobeEvent();
        this.nextStepReady.emit(true);
    }

    tagNextStepLoadAdobeEvent(): void {
        switch (this.accessType) {
            case AccessTypeSelection.INFORMATION_ONLY:
                this.onNextStepLoadAdobeEventInfoOnly();
                break;
            case AccessTypeSelection.LIMITED_ACCESS:
                this.onNextStepLoadAdobeEventLimited();
                break;
        }
    }
}
